module.exports = __webpack_public_path__ + "static/media/m_beard_balbo_long__square_vector.b5506486.svg";